import {createAction, props} from '@ngrx/store';
import {Listing} from '../../shared/models/listing.interface';

export const setBookingParams = createAction('[Book] set booking params', props<{ listing?: Listing }>());
export const setBookingMessage = createAction('[Book] set booking message', props<{ bookingMessage: string }>());
